import axios from 'axios';

const KRA_GATEWAY_BASE = 'https://cs.fabbuilder.com/cs-app/kra';

export interface CheckKycPayload {
  pan: string;
  leadId: string;
}

export interface FetchPanDetailsPayload {
  panNo: string;
  dobOrIncorp: string;
  leadId: string;
}

export const kycApi = {
  checkKyc: async (tenantId: string, payload: CheckKycPayload) => {
    const response = await axios.post(
      `${KRA_GATEWAY_BASE}/api/tenant/${tenantId}/CvlKra/check-kyc`,
      payload,
    );
    return response.data;
  },

  fetchPanDetails: async (tenantId: string, payload: FetchPanDetailsPayload) => {
    const response = await axios.post(
      `${KRA_GATEWAY_BASE}/api/tenant/${tenantId}/CvlKra/fetch-pan-details`,
      { ...payload, kraCode: 'CVLKRA', fetchType: 'I' },
    );
    return response.data;
  },
};
